import { FUNC_NOOP } from '@libs/constants';

import { usePlayerGameStatsQuery } from '@features/user/api/hooks';
import { PlayerShieldAvatar } from '@features/user/ui/PlayerShieldAvatar/PlayerShieldAvatar';

type Props = {
  className?: string;
  userId?: string;
  isWidget?: boolean;
};
export function PlayerShieldAvatarWidget({ className, userId, isWidget }: Props) {
  const { data: playerStats } = usePlayerGameStatsQuery({
    userId,
  });

  return (
    <PlayerShieldAvatar
      className={className}
      size="l"
      stats={playerStats}
      popoverDescriptionsEnabled
      onMouseEnter={FUNC_NOOP}
      onMouseLeave={FUNC_NOOP}
      isWidget={isWidget || false}
    />
  );
}
